import React, {Component} from 'react';
import './App.sass';
import DNDWrapper from "./components/DNDWrapper";

const items = window.constructorItems.map(item => ({...item, hidden: false}));

export default class App extends Component {
  state = {
    initialItems: items
  };

  render(){
    const {initialItems} = this.state;
    return <DNDWrapper initialItems={initialItems}/>
  }
}
